import { blazeTheme } from './blaze';
import { lightspeedTheme } from './lightspeed';
import type { ThemeManifest, ThemePreset } from './types';
import { isThemePreset, DEFAULT_THEME_PRESET } from './types';

import './lightspeed/tokens.css';

export const THEMES: Record<ThemePreset, ThemeManifest> = {
  blaze: blazeTheme,
  lightspeed: lightspeedTheme,
};

export function resolveTheme(value: unknown): ThemeManifest {
  return isThemePreset(value) ? THEMES[value] : THEMES[DEFAULT_THEME_PRESET];
}

export { THEME_PRESETS, DEFAULT_THEME_PRESET, isThemePreset } from './types';
export type { ThemeManifest, ThemePreset, ThemeComponents } from './types';
